import { RefObject, useEffect, useRef, useState } from 'react';

function useComponentVisible(
  initialIsVisible: boolean,
  shouldPersistOnClick: boolean = false,
  portalRef?: RefObject<HTMLElement>
) {
  const [isComponentVisible, setIsComponentVisible] =
    useState(initialIsVisible);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shouldPersistOnClick) return;
    if (!isComponentVisible) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return;

      // Check if click is inside the ref element
      if (ref.current?.contains(event.target)) return;

      // Check if click is inside portaled content
      if (portalRef?.current?.contains(event.target)) return;

      setIsComponentVisible(false);
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [shouldPersistOnClick, portalRef, isComponentVisible]);

  return { ref, isComponentVisible, setIsComponentVisible };
}

export { useComponentVisible };
